import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function OtlVideo() {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} className="border-t border-charcoal/10 pt-16" data-id="element-394" data-mp="3ra72u9p2w7f2">
      <div className="max-w-3xl mx-auto text-center mb-10" data-id="element-395" data-mp="91y36u7ps1bj">
        <p className="text-charcoal/80 font-light leading-relaxed" data-id="element-396" data-mp="45qy13n56tun">
          Para comprender mejor la importancia de la integración de la
          información geográfica, catastral y ambiental, así como el papel de
          los OTL y del modelo LADM en la administración del territorio, la
          gestión ambiental y los beneficios que aportan, los invitamos a ver el
          siguiente video:
        </p>
      </div>

      <div className="relative w-full max-w-4xl mx-auto bg-charcoal overflow-hidden" style={{
      aspectRatio: '16/9'
    }} data-id="element-397" data-mp="3hi132dsl4lpb">
        <iframe loading="lazy" title="Gumlet video player" src="https://play.gumlet.io/embed/6a3516c7ba0085952b286531?background=false&autoplay=false&loop=false&disable_player_controls=false" style={{
        border: 'none',
        position: 'absolute',
        top: 0,
        left: 0,
        height: '100%',
        width: '100%'
      }} referrerPolicy="origin" allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture; fullscreen;clipboard-write;" data-id="element-398" data-mp="2ovq04whia8pc" />
      </div>

      <div className="max-w-4xl mx-auto mt-4 text-center" data-id="element-399" data-mp="2wgct9lcn75e0">
        <p className="text-xs text-charcoal/50 font-light" data-id="element-400" data-mp="2whxold6s6scx">
          Fuente: Banco Mundial, Programa Ciudata+, con el apoyo de la Embajada
          Suiza en Colombia (SECO).
        </p>
      </div>
    </motion.div>;
}